import {
  GetButtonLabel,
  SelectPlanCTAText,
} from '../../../../../../../../../shared/design-system/components/molecules/pricing-card/types';
import { Images } from '../../../../../../../../../shared/app-constants';
import { BillingOption } from '../../../../../../../../../shared/utils/billing-options';
import { SubscriptionPlanTitle } from '../../../../../../../../../shared/utils/subscription-plans';
import { GetPlansResponse } from '../../../../../types';
import { checkIsDemoPlanUser } from '../../../../../../../../../shared/design-system/components/molecules/subscription-plan-details/helper/helper';

const inboxRadarBasicMonthlyFeatures = [
  {
    label: '120 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '50 Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'One-time Tests',
    tooltipText: 'Run a single test with a one-time frequency.',
    tooltipClassName: 'inbox-radar-custom-tooltip-align-left',
  },
  {
    label: 'Placement Improvement Insights',
    tooltipText: 'Get actionable insights to improve the inbox placement rate.',
  },
  {
    label: 'SpamAssassin Score Analysis',
    tooltipText: 'Identify spam triggers in email',
  },
  {
    label: 'Domain & IP Reputation Report',
    tooltipText: 'Get report on blacklisted IP and Domain',
  },
  {
    label: 'Inbox Placement Insights',
    tooltipText: 'Get inbox insights and spot spam issues',
  },
  {
    label: 'Historical Trend Dashboard',
  },
];
const inboxRadarBasicQuarterlyFeatures = [
  {
    label: '120 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '50 Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'One-time Tests',
    tooltipText: 'Run a single test with a one-time frequency.',
    tooltipClassName: 'inbox-radar-custom-tooltip-align-left',
  },
  {
    label: 'Placement Improvement Insights',
    tooltipText: 'Get actionable insights to improve the inbox placement rate.',
  },
  {
    label: 'SpamAssassin Score Analysis',
    tooltipText: 'Identify spam triggers in email',
  },
  {
    label: 'Domain & IP Reputation Report',
    tooltipText: 'Get report on blacklisted IP and Domain',
  },
  {
    label: 'Inbox Placement Insights',
    tooltipText: 'Get inbox insights and spot spam issues',
  },
  {
    label: 'Historical Trend Dashboard',
  },
];
const inboxRadarBasicYearlyFeatures = [
  {
    label: '120 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '50 Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'One-time Tests',
    tooltipText: 'Run a single test with a one-time frequency.',
    tooltipClassName: 'inbox-radar-custom-tooltip-align-left',
  },
  {
    label: 'Placement Improvement Insights',
    tooltipText: 'Get actionable insights to improve the inbox placement rate.',
  },
  {
    label: 'SpamAssassin Score Analysis',
    tooltipText: 'Identify spam triggers in email',
  },
  {
    label: 'Domain & IP Reputation Report',
    tooltipText: 'Get report on blacklisted IP and Domain',
  },
  {
    label: 'Inbox Placement Insights',
    tooltipText: 'Get inbox insights and spot spam issues',
  },
  {
    label: 'Historical Trend Dashboard',
  },
];
const inboxRadarProMonthlyFeatures = [
  {
    label: 'Everything in the Starter Plan',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '100 Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '250 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Recurring Automated Tests',
  },
  {
    label: 'Exportable Test Reports',
    tooltipText: 'Share reports with your team for collaboration',
  },
  {
    label: 'Test Scheduling',
    tooltipText: 'Select how emails are sent in your sequence',
  },
  {
    label: 'Advanced Deliverability Triggers and Action',
    highlight: false,
    // labelClass: 'font-semibold',
    tooltipText:
      'Auto-pause email account or sequence if inbox score drops below your set limit, with instant alerts',
    tooltipClassName: 'inbox-radar-custom-tooltip',
  },
];
const inboxRadarProQuarterlyFeatures = [
  {
    label: 'Everything in the Starter Plan',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '250 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '100 Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Recurring Automated Tests',
  },
  {
    label: 'Exportable Test Reports',
    tooltipText: 'Share reports with your team for collaboration',
  },
  {
    label: 'Test Scheduling',
    tooltipText: 'Select how emails are sent in your sequence',
  },
  {
    label: 'Advanced Deliverability Triggers and Action',
    highlight: false,
    // labelClass: 'font-semibold',
    tooltipText:
      'Auto-pause email account or sequence if inbox score drops below your set limit, with instant alerts',
    tooltipClassName: 'inbox-radar-custom-tooltip',
  },
];
const inboxRadarProYearlyFeatures = [
  {
    label: 'Everything in the Starter Plan',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '250 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '100 Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Recurring Automated Tests',
  },
  {
    label: 'Exportable Test Reports',
    tooltipText: 'Share reports with your team for collaboration',
  },
  {
    label: 'Test Scheduling',
    tooltipText: 'Select how emails are sent in your sequence',
  },
  {
    label: 'Advanced Deliverability Triggers and Action',
    highlight: false,
    // labelClass: 'font-semibold',
    tooltipText:
      'Auto-pause email account or sequence if inbox score drops below your set limit, with instant alerts',
    tooltipClassName: 'inbox-radar-custom-tooltip',
  },
];

const inboxRadarScaleMonthlyFeatures = [
  {
    label: 'Everything in the Pro Plan',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '600 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
];
const inboxRadarScaleQuarterlyFeatures = [
  {
    label: 'Everything in the Pro Plan',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '600 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
];
const inboxRadarScaleYearlyFeatures = [
  {
    label: 'Everything in the Pro Plan',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: '600 Tests per Month',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Sending Email Accounts Per Test',
    labelClass: 'font-semibold',
    highlight: true,
  },
];

const planMetaData = {
  [SubscriptionPlanTitle.InboxRadarBasicMonthly]: {
    displayName: 'Inbox Starter',
    features: inboxRadarBasicMonthlyFeatures,
  },
  [SubscriptionPlanTitle.InboxRadarProMonthly]: {
    displayName: 'Inbox Pro',
    features: inboxRadarProMonthlyFeatures,
    isBestValuePlan: true,
  },
  [SubscriptionPlanTitle.InboxRadarScaleMonthly]: {
    displayName: 'Inbox Scale',
    features: inboxRadarScaleMonthlyFeatures,
  },
  [SubscriptionPlanTitle.InboxRadarBasicQuarterly]: {
    displayName: 'Inbox Starter',
    features: inboxRadarBasicQuarterlyFeatures,
  },
  [SubscriptionPlanTitle.InboxRadarProQuarterly]: {
    displayName: 'Inbox Pro',
    features: inboxRadarProQuarterlyFeatures,
    isBestValuePlan: true,
  },
  [SubscriptionPlanTitle.InboxRadarScaleQuarterly]: {
    displayName: 'Inbox Scale',
    features: inboxRadarScaleQuarterlyFeatures,
  },
  [SubscriptionPlanTitle.InboxRadarBasicYearly]: {
    displayName: 'Inbox Starter',
    features: inboxRadarBasicYearlyFeatures,
  },
  [SubscriptionPlanTitle.InboxRadarProYearly]: {
    displayName: 'Inbox Pro',
    features: inboxRadarProYearlyFeatures,
    isBestValuePlan: true,
  },
  [SubscriptionPlanTitle.InboxRadarScaleYearly]: {
    displayName: 'Inbox Scale',
    features: inboxRadarScaleYearlyFeatures,
  },
};

export const getInboxRadarPlanMetaData = (planName) => planMetaData[planName];

export const getPlanPrice = (planPrice, planMode) =>
  Number(planPrice) / Number(planMode);

const extractPlanCode = (
  planCode: string,
): 'basic' | 'pro' | 'scale' | null => {
  if (planCode?.includes('basic')) return 'basic';
  if (planCode?.includes('pro')) return 'pro';
  if (planCode?.includes('scale')) return 'scale';
  return null;
};

const planCodeHierarchy = ['basic', 'pro', 'scale'];

export const getButtonLabel = ({
  plan,
  sendGetInboxAnalyzerSubscriptionResponse,
  planCycle,
}: GetButtonLabel) => {
  if (checkIsDemoPlanUser()) {
    return SelectPlanCTAText.UpgradePlan;
  }
  const {
    planMode,
    planId: subscriptionId,
    planCode,
  } = sendGetInboxAnalyzerSubscriptionResponse;

  const currentPlan = extractPlanCode(planCode);
  const selectedPlan = extractPlanCode(plan?.planCode || '');

  const currentIndex = planCodeHierarchy?.indexOf(currentPlan || '');
  const selectedIndex = planCodeHierarchy?.indexOf(selectedPlan || '');

  if (currentPlan === selectedPlan) {
    if (planMode === 1 && planCycle !== BillingOption.MONTHLY) {
      return SelectPlanCTAText.DowngradePlan;
    }
    return SelectPlanCTAText.CurrentPlan;
  }

  if (selectedIndex < currentIndex) {
    return SelectPlanCTAText.DowngradePlan;
  }

  if (selectedIndex > currentIndex) {
    return SelectPlanCTAText.UpgradePlan;
  }

  if (subscriptionId) {
    if (subscriptionId === plan.id) {
      return SelectPlanCTAText.CurrentPlan;
    }
  }

  return SelectPlanCTAText.UpgradePlan;
};

export const getPlanDetailsObj = (plan, isUserSubscribed) => ({
  id: plan?.id || null,
  planName: plan?.planName,
  displayName: getInboxRadarPlanMetaData(plan?.planName)?.displayName,
  isBestValuePlan: getInboxRadarPlanMetaData(plan?.planName)?.isBestValuePlan,
  features: isUserSubscribed
    ? getInboxRadarPlanMetaData(plan?.planName)?.features?.filter(
        (feature) => !feature?.label?.includes('Free Lead Finder Credits'),
      )
    : getInboxRadarPlanMetaData(plan?.planName)?.features,
  price: getPlanPrice(plan?.amount, plan?.planMode) || null,
  ...plan,
});

export const getInboxAnalyzerPlanMonthlyPrice = (
  planCode: string,
  plans: GetPlansResponse,
) => {
  const correspondingMonthlyPlanCode =
    planCode?.replace('yearly', 'monthly') || '';

  const correspondingMonthlyPlan = plans.find(
    (plan) => plan.planCode === correspondingMonthlyPlanCode,
  );

  if (correspondingMonthlyPlan) {
    return parseInt(correspondingMonthlyPlan?.amount || '0', 10);
  }

  return 0;
};

export const getInboxAnalyzerPlanQuarterlyPrice = (
  planCode: string,
  plans: GetPlansResponse,
) => {
  const correspondingMonthlyPlanCode =
    planCode?.replace('yearly', 'quarterly') || '';

  const correspondingMonthlyPlan = plans.find(
    (plan) => plan.planCode === correspondingMonthlyPlanCode,
  );

  if (correspondingMonthlyPlan) {
    return parseInt(correspondingMonthlyPlan?.amount || '0', 10);
  }

  return 0;
};

export const getInboxAnalyzerPlanYearlyPrice = (
  planCode: string,
  plans: GetPlansResponse,
) => {
  const correspondingYearlyPlanCode =
    planCode?.replace('monthly', 'yearly') || '';

  const correspondingYearlyPlan = plans.find(
    (plan) => plan.planCode === correspondingYearlyPlanCode,
  );

  if (correspondingYearlyPlan) {
    return parseInt(correspondingYearlyPlan?.amount || '0', 10);
  }

  return 0;
};

export const stepWisePlanProspects = {
  step1: '100,000',
  step2: '200,000',
  step3: '300,000',
  step4: '400,000',
  step5: '500,000',
  step6: '500,000+',
};

export const getSelectedPlanProspects = (step) =>
  stepWisePlanProspects[`step${step}`];

export const getInitialStepValue = (planId, planMode) => {
  const planIdWiseStep = {
    97: 1,
    98: 2,
    99: 3,
    100: 4,
    101: 5,
  };

  if (planMode === 12 && planId >= 97) {
    return planIdWiseStep[planId];
  }

  return 1;
};

export const getCustomScalePlusDiscountPer = (step) => {
  const stepWiseDiscount = {
    step1: '27',
    step2: '30',
    step3: '31',
    step4: '32',
    step5: '32',
  };

  return stepWiseDiscount[`step${step}`];
};

export const getPlansIcon = (planName) => {
  const planIconMap = {
    [SubscriptionPlanTitle.InboxRadarBasicMonthly]: Images.RocketColor,
    [SubscriptionPlanTitle.InboxRadarProMonthly]: Images.HeartColor,
    [SubscriptionPlanTitle.InboxRadarScaleMonthly]: Images.StarColor,
    [SubscriptionPlanTitle.InboxRadarBasicQuarterly]: Images.RocketColor,
    [SubscriptionPlanTitle.InboxRadarProQuarterly]: Images.HeartColor,
    [SubscriptionPlanTitle.InboxRadarScaleQuarterly]: Images.StarColor,
    [SubscriptionPlanTitle.InboxRadarBasicYearly]: Images.RocketColor,
    [SubscriptionPlanTitle.InboxRadarProYearly]: Images.HeartColor,
    [SubscriptionPlanTitle.InboxRadarScaleYearly]: Images.StarColor,
  };

  return planIconMap[planName];
};
